import { string } from 'prop-types'
import { Component } from 'react'

import { IS_DEVELOPMENT } from 'shared/consts'
import getComponentDisplayName from 'shared/utils/getComponentDisplayName'

const withDataQA = ComposedComponent => {
  class WithDataQA extends Component {
    static propTypes = {
      dataQa: string,
      dataQaId: string,
    }

    static defaultProps = {
      dataQa: null,
      dataQaId: null,
    }

    render() {
      const { dataQa, dataQaId, ...rest } = this.props

      if (!dataQa && !dataQaId) {
        return <ComposedComponent {...rest} />
      }

      return (
        <>
          {dataQaId ? (
            <span data-qa-id={dataQaId} className="u-hidden" />
          ) : (
            <span data-qa={dataQa} className="u-hidden" />
          )}
          <ComposedComponent {...rest} />
        </>
      )
    }
  }

  if (IS_DEVELOPMENT) {
    WithDataQA.displayName = getComponentDisplayName(ComposedComponent)
  }

  return WithDataQA
}

export default withDataQA
